<template>
  <div class="the-hub__message" role="alert">
    <font-awesome-icon :icon="['fas', 'info-circle']" class="the-hub__message-icon" />
    <div>
      <h2 class="the-hub__message-title">{{ title }}</h2>
      <p class="the-hub__message-text">Please try again shortly.</p>
      <div class="the-hub__message-actions">
        <button type="button" class="the-hub__message-retry" @click="$emit('retry')">Try again</button>
        <nuxt-link v-if="showBackLink" to="/the-hub" class="the-hub__message-back">Back to The Hub</nuxt-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TheHubErrorMessage',
  props: {
    title: { type: String, required: true },
    showBackLink: { type: Boolean, required: false, default: true }
  }
}
</script>

<style lang="scss" scoped>
.the-hub__message {
  display: flex;
  align-items: flex-start;
  gap: 15px;
  margin: 30px 0;
  padding: 20px 25px;
  background: #fdecec;
  border: 1px solid #f5b5b8;
  border-left: 5px solid #e1000b;
  border-radius: 4px;
  color: #363636;
  &-icon {
    flex: 0 0 auto;
    margin-top: 3px;
    font-size: 24px;
    color: #e1000b;
  }
  &-title {
    margin: 0 0 6px;
    font-size: 20px;
    font-weight: 700;
  }
  &-text {
    margin: 0 0 15px;
    font-size: 15px;
  }
  &-actions {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 20px;
  }
  &-retry {
    padding: 10px 20px;
    border: 0;
    border-radius: 3px;
    background: #e1000b;
    color: #fff;
    font-weight: 700;
    text-transform: uppercase;
    cursor: pointer;
    &:hover {
      background: #303030;
    }
  }
  &-back {
    color: #363636;
    text-decoration: underline;
    &:hover {
      color: #e1000b;
    }
  }
}
</style>
